import InputTypesEnum from '../../../Enums/InputTypesEnum';

/**
 * Declarative configuration for every input type that is rendered as a generic
 * lookup-item select (the old `renderLookupSelect(lookupId, onlyActive, sort, valueAsText)`
 * switch cases). Each key is an `InputTypesEnum` value; the value carries the
 * arguments that used to be passed positionally.
 *
 * To add a new lookup-backed dropdown, just add an entry here — no new render
 * method or switch case is needed.
 */
const LOOKUP_SELECT_CONFIG = {
  [InputTypesEnum.IndustryLookupItemSelect]: { lookupId: 6 },
  [InputTypesEnum.SourceLookupItemSelect]: { lookupId: 7 },
  [InputTypesEnum.ServiceType]: { lookupId: 15 },
  [InputTypesEnum.CommonGenderLookupItemSelect]: { lookupId: 17 },
  [InputTypesEnum.CommonMaritalStatusLookupItemSelect]: { lookupId: 18 },
  [InputTypesEnum.OpportunityReasonLost]: { lookupId: 26 },
  [InputTypesEnum.EducationLevelLookupItemSelect]: { lookupId: 34 },
  [InputTypesEnum.OtherValidationRequirementLookupItemSelect]: { lookupId: 35 },
  [InputTypesEnum.EvaluatorRotation]: { lookupId: 36 },
  [InputTypesEnum.CommonCycle]: { lookupId: 16 },
  [InputTypesEnum.CommonDataCaptureMethodLookupItemSelect]: { lookupId: 21 },
  [InputTypesEnum.EvaluationTypeLookupItemSelect]: { lookupId: 61 },
  [InputTypesEnum.OfficialJobTitleLookupItemSelect]: { lookupId: 68 },
  [InputTypesEnum.DepartmentLookupItemSelect]: { lookupId: 69 },
  [InputTypesEnum.TierLookupItemSelect]: { lookupId: 67 },
  [InputTypesEnum.LeadLookupSelect]: { lookupId: 5 },
  [InputTypesEnum.ServiceFeeTypeLookupSelect]: { lookupId: 71, onlyActive: true },
  [InputTypesEnum.OpportunityTypeLookupItemSelect]: { lookupId: 72 },
  [InputTypesEnum.MsPartnerSelect]: { lookupId: 83 },
  [InputTypesEnum.MaxDeliveryAfterShop]: { lookupId: 37 },
  [InputTypesEnum.ChileBankNameCodeLookupSelect]: { lookupId: 104 },
  [InputTypesEnum.ChinaBankNameCodeLookupSelect]: { lookupId: 103 },
  [InputTypesEnum.LocationListOptionsLookupItemSelect]: { lookupId: 105 },
  [InputTypesEnum.ReportLanguageLookupItemSelect]: { lookupId: 107 },
  [InputTypesEnum.AreaTypeLookupItemSelect]: { lookupId: 106 },
  [InputTypesEnum.CommonContactMethodLookupItemSelect]: { lookupId: 9 },
  [InputTypesEnum.CommonReferralSourceLookupItemSelect]: { lookupId: 7 },
  [InputTypesEnum.AddressTypeLookupSelect]: { lookupId: 8 },
  [InputTypesEnum.ClientStatusLookupItemSelect]: { lookupId: 14 },
  [InputTypesEnum.InvoiceDaysToPayLookupItemSelect]: { lookupId: 39 },
  [InputTypesEnum.TimeZone]: { lookupId: 27 },
  [InputTypesEnum.PricingStatusLookupItemSelect]: { lookupId: 23 },
  [InputTypesEnum.IobLineItemTypeLookupItemSelect]: { lookupId: 51 },
  [InputTypesEnum.CreditMemoReasonLookupItemSelect]: { lookupId: 48 },
  [InputTypesEnum.EvaluatorPaymentMethodLookupItemSelect]: { lookupId: 47 },
  [InputTypesEnum.EvaluatorPaymentTypeLookupItemSelect]: { lookupId: 46 },
  [InputTypesEnum.EvaluatorPaymentStatusLookupItemSelect]: { lookupId: 45 },
  [InputTypesEnum.ClientLineTypeLookupItemSelect]: { lookupId: 42, sort: true },
  [InputTypesEnum.ClientPaymentTypeLookupSelect]: { lookupId: 53, onlyActive: true, sort: true },
  [InputTypesEnum.ClientPaymentTypeLookupTextSelect]: { lookupId: 53, onlyActive: true, sort: true, valueAsText: true },
  [InputTypesEnum.ClientPaymentRefundReasonSelect]: { lookupId: 57, onlyActive: true, sort: true },
  [InputTypesEnum.ClientPaymentRefundMethodSelect]: { lookupId: 58, onlyActive: true, sort: true },
  [InputTypesEnum.MysteryShoppingPlatformPricingLookupSelect]: { lookupId: 109, onlyActive: true, sort: true },
  [InputTypesEnum.CallRecordingCostLookupSelect]: { lookupId: 110, onlyActive: true, sort: true },
  [InputTypesEnum.CsatCostLookupSelect]: { lookupId: 111, onlyActive: true, sort: true },
  [InputTypesEnum.IvrCostLookupSelect]: { lookupId: 112, onlyActive: true, sort: true },
  [InputTypesEnum.TpCreditMemoReasonLookupItemSelect]: { lookupId: 48, onlyActive: true, sort: true, valueAsText: true },
};

export default LOOKUP_SELECT_CONFIG;
